import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { RegionsSelector } from '@reveni-io/reveni-ui'

import { getSelectedRegionsForMultiSelect, groupRegionsByContinent } from '@/common/helpers/helpers'

const RegionFilter = ({ regions, value, onChange, label }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const handleChange = value => {
    onChange(value.map(v => v.id))
  }

  return (
    <RegionsSelector
      label={t(label || 'Regiones')}
      regions={groupRegionsByContinent(regions) || []}
      value={getSelectedRegionsForMultiSelect(value, regions)}
      onChange={handleChange}
      inputBackgroundColor={theme.colors.background.secondary}
    />
  )
}

export default RegionFilter
